import React from 'react';
import classNames from 'classnames';

import Sticker, {
  Props as StickerProps,
} from 'components/Common/Sticker/Sticker';
import {
  formatCommercialOperationSticker,
  formatMainSticker,
} from 'services/product/formatter';
import { ProductStickersType } from 'types/ProductPageV2/Products';

import styles from './ProductStickers.module.scss';

export type Props = {
  stickers: ProductStickersType;
  classes?: { container?: string };
  onClick?: (label: string) => void;
};

/**
 * Product page of website. Contains product stickers data.
 */
export default function ProductStickers({
  stickers: { commercialOperation, principal, secondary1, secondary2 },
  classes,
  onClick,
}: Props): JSX.Element {
  const stickerList = [
    formatCommercialOperationSticker(commercialOperation ?? ''),
    { label: secondary1, className: styles.pinkSticker },
    (() => {
      const { label, image } = formatMainSticker(principal ?? '');

      return {
        label,
        image: image ? { src: image, alt: label } : undefined,
      };
    })(),
    { label: secondary2 },
  ].filter(({ label }) => label) as (StickerProps['sticker'] & {
    className?: string;
  })[];

  return (
    <div className={classNames(styles.stickerContainer, classes?.container)}>
      {stickerList.map(({ label, className, ...rest }, index) => (
        <Sticker
          key={index}
          onClick={() => onClick?.(label)}
          sticker={{ label, ...rest }}
          className={className}
        />
      ))}
    </div>
  );
}
